export const getStars = (value: any) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }
  return "*".repeat(value.length);
};

export const maskStarsText = (text: any) => {
  if (!text) return "";

  if (text.length <= 4) return text;

  return text.substring(0, 4) + "**";
};

export const getTwoStars = (value: any) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }
  return "*".repeat(2);
};

export const getSecretId = (value: any) => {
  return value.substring(0, 6) + "********" + value.substring(14, 18);
};

export const getSecretPhone = (value: any) => {
  return value.substring(0, 3) + "****" + value.substring(7, 11);
};

type DesensitizationRuntimeContext = {
  data?: {
    rawValue?: unknown;
    displayValue?: unknown;
    [key: string]: unknown;
  };
};

type ResolvedDesensitizationDisplayValue = {
  hasValue: boolean;
  value: string;
};

function isEmptyDisplaySource(value: unknown) {
  return value === undefined || value === null || value === "";
}

function isPlaceholderDisplayValue(value: unknown) {
  return value === "-";
}

function hasOwnValue(
  value: Record<string, unknown>,
  key: string,
): boolean {
  return Object.prototype.hasOwnProperty.call(value, key);
}

export function resolveDesensitizationDisplayValue(
  copyableText?: string,
  runtimeContext?: DesensitizationRuntimeContext,
): ResolvedDesensitizationDisplayValue {
  if (!isEmptyDisplaySource(copyableText)) {
    return {
      hasValue: true,
      value: String(copyableText),
    };
  }

  const data = runtimeContext?.data;
  if (!data) {
    return {
      hasValue: false,
      value: "",
    };
  }

  const rawValue = data.rawValue;
  if (hasOwnValue(data, "rawValue") && isEmptyDisplaySource(rawValue)) {
    return {
      hasValue: false,
      value: "",
    };
  }

  const displayValue = data.displayValue;
  if (
    !hasOwnValue(data, "rawValue") &&
    isPlaceholderDisplayValue(displayValue)
  ) {
    return {
      hasValue: false,
      value: "",
    };
  }

  const resolvedValue = !isEmptyDisplaySource(displayValue)
    ? displayValue
    : rawValue;

  if (
    isEmptyDisplaySource(resolvedValue) ||
    isPlaceholderDisplayValue(resolvedValue)
  ) {
    return {
      hasValue: false,
      value: "",
    };
  }

  return {
    hasValue: true,
    value: String(resolvedValue),
  };
}
